const defaultUri = process.env.REACT_APP_BACK_URL_ALTERED;
const localStorageTokenKey = 'KlabWebLocalToken';

class Connection2 {
  static _abortController = new AbortController();

  static getToken = () => {
    return localStorage.getItem(localStorageTokenKey);
  };

  static setToken = (token: string) => {
    localStorage.setItem(localStorageTokenKey, token);
  };

  static _request = async (
    method: 'POST' | 'PATCH' | 'GET' | 'DELETE' | 'PUT',
    path: string,
    body?: any
  ) => {
    const token = this.getToken();
    const uri = defaultUri + path;
    const timeoutId = setTimeout(() => {
      this._abortController.abort();
    }, 4000);
    const response = await fetch(uri, {
      method: method,
      headers: {
        proxy: defaultUri!,
        'Content-Type': 'application/json',
        authorization: token ? `Bearer ${token}` : '',
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    clearTimeout(timeoutId);
    if (response.ok) {
      const res = await response.json();
      if (res.code === 200 || res.code === '200') return res;
      else //NOTE - All code is not 200, throw Error
        throw new Error(`${res.code} ${res.errorMessage}`);
    } else {
      throw new Error(`${response.status} ${response.statusText}`);
    }
  };

  static requestDelete = async (path: string, body: any) => {
    return this._request('DELETE', path, body);
  };

  static requestPatch = async (path: string, body: any) => {
    return this._request('PATCH', path, body);
  };

  static requestPost = async (path: string, body: any) => {
    return this._request('POST', path, body);
  };

  static requestGet = async (path: string) => {
    return this._request('GET', path);
  };
}

export default Connection2;
